export default __webpack_public_path__ + "static/media/IronmanTriathlon.0acd8362.png";